export const URL = '/v1/auth/logout/'

export type Req = any

export type Resp = {
  success: boolean
}
